import { configureStore } from '@reduxjs/toolkit';
import companiesSlice from './slices/companiesSlice';

const store = configureStore({
  reducer: {
    companies: companiesSlice,
  },
});

export default store;
